import React from 'react';
import { Link } from 'react-router-dom';

import classNames from 'classnames';
import Icon from 'components/icons';
import { I18n } from 'components/translate';
import { ROUTES } from 'configs/routes/constants';
import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';

const ClassListViewCreateButton = ({ className }) => {
  const handleClick = () => {
    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        category: EVENTS_CATEGORY.CLASS.NEW_CLASS,
        action: EVENTS_INTERACTIONS.CLICK
      })
    });
  };

  return (
    <Link
      to={ROUTES.CLASS.NEW}
      className={classNames(
        className,
        'hot-button hot-button--primary _text-decoration-none'
      )}
      onClick={handleClick}
    >
      <Icon prefix="fal" iconName="plus" className="_mr-2" />
      <I18n label="class_manager.class_list.create_class" checkOnlineEvent />
    </Link>
  );
};

export default ClassListViewCreateButton;
